import type { App } from 'vue'
import C2Button from '@/ui/components/C2Button.vue'
import C2Checkbox from '@/ui/components/C2Checkbox.vue'
import C2Field from '@/ui/components/C2Field.vue'
import C2Input from '@/ui/components/C2Input.vue'
import C2InputPhone from '@/ui/components/C2InputPhone.vue'
import C2Modal from '@/ui/components/C2Modal.vue'
import C2Radio from '@/ui/components/C2Radio.vue'
import C2Skeleton from '@/ui/components/C2Skeleton.vue'

export function registerAuthUi(app: App) {
  app.component('C2Button', C2Button)
  app.component('C2Checkbox', C2Checkbox)
  app.component('C2Field', C2Field)
  app.component('C2Input', C2Input)
  app.component('C2InputPhone', C2InputPhone)
  app.component('C2Modal', C2Modal)
  app.component('C2Radio', C2Radio)
  app.component('C2Skeleton', C2Skeleton)
}
